import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { APP_CONST } from "../../../../config/const";
import { APP_ERRORS } from "../../../../config/appErrors";

const BankDetailsForm = ({
  handleSubmit,
  isLoading,
  isEditMode,
  selectedBankDetails,
}) => {
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({});
  const [formDetailsType, setFormDetailsType] = useState(
    APP_CONST.PLAYER_BANK_DETAILS_TYPE.Bank
  );
  useEffect(() => {
    if (isEditMode && selectedBankDetails) {
      setFormData((p) => ({ accountName: selectedBankDetails?.name }));
    }
  }, [isEditMode]);

  const validateBankData = (realTimeData) => {
    const dataToValidate = realTimeData ? realTimeData : formData;
    const { accountName, accountNumber, ifscCode, type } = dataToValidate;
    let errorsObject = {};
    if (!Boolean(accountName) || accountName == "") {
      errorsObject["accountName"] = APP_ERRORS.PLAYER_BANK_DETAILS.ACCOUNT_NAME;
    }
    if (!Boolean(accountNumber) || accountNumber == 0 || accountNumber == "") {
      errorsObject["accountNumber"] =
        APP_ERRORS.PLAYER_BANK_DETAILS.ACCOUNT_NUMBER;
    }
    if (!Boolean(ifscCode) || ifscCode == "") {
      errorsObject["ifscCode"] = APP_ERRORS.PLAYER_BANK_DETAILS.IFSC_CODE;
    }

    setFormErrors(errorsObject);
    return errorsObject;
  };

  const validateCardData = (realTimeData) => {
    const dataToValidate = realTimeData ? realTimeData : formData;
    let errorsObject = {};
    const { cardName, cardNo, expiryMonth, expiryYear, cvv, type } =
      dataToValidate;

    if (!Boolean(cardName) || cardName == "") {
      errorsObject["cardName"] = APP_ERRORS.PLAYER_BANK_DETAILS.CARD_NAME;
    }
    if (!Boolean(cardNo) || cardNo == "" || cardNo == 0) {
      errorsObject["cardNo"] = APP_ERRORS.PLAYER_BANK_DETAILS.CARD_NO;
    }
    if (!Boolean(expiryMonth) || expiryMonth == "") {
      errorsObject["expiryMonth"] = APP_ERRORS.PLAYER_BANK_DETAILS.EXPIRY_MONTH;
    }
    if (!Boolean(expiryYear) || expiryYear == "") {
      errorsObject["expiryYear"] = APP_ERRORS.PLAYER_BANK_DETAILS.EXPIRY_YEAR;
    }
    if (!Boolean(cvv) || cvv == "") {
      errorsObject["cvv"] = APP_ERRORS.PLAYER_BANK_DETAILS.CVV;
    }

    setFormErrors(errorsObject);
    return errorsObject;
  };
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const tempFormData = { ...formData, [name]: value, type: formDetailsType };
    formDetailsType === APP_CONST.PLAYER_BANK_DETAILS_TYPE.Bank
      ? validateBankData(tempFormData)
      : validateCardData(tempFormData);
    setFormData(tempFormData);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const errors = validateBankData();

    if (Object.entries(errors).length === 0) {
      handleSubmit(formData);
    }
  };

  const handleCardFormSubmit = (e) => {
    e.preventDefault();
    const errors = validateCardData();
    if (Object.entries(errors).length == 0) {
      handleSubmit(formData);
    }
  };
  // type : string;
  // accountName? : string;
  // accountNumber? : number;
  // ifscCode? : string;
  // cardName? : string;
  // cardNo? : number;
  // expiryMonth? : number;
  // expiryYear? : number;
  // cvv? : number;

  //bank
  // accountName: z.string(),
  // accountNumber: z.number(),
  // ifscCode: z.string(),
  // type: z.nativeEnum(PlayerBankModes),

  //card
  // cardName: z.string(),
  // cardNo: z.number(),
  // expiryMonth: z.number(),
  // expiryYear: z.number(),
  // cvv: z.number(),
  // type: z.nativeEnum(PlayerBankModes),

  const renderBankDetailsForm = () => {
    return (
      <Form
        className={isEditMode ? "playerBankDetailsEdit" : "playerBankDetails"}
        onSubmit={handleFormSubmit}
      >
        <Form.Select
          aria-label="Default select example"
          className="mb-3 position-relative"
          onChange={(e) => {
            setFormDetailsType(e.target.value);
            // handleChange(e);
          }}
          value={formDetailsType}
          // value={bankDetails.type}
          disabled={true}
        >
          <option value={APP_CONST.PLAYER_BANK_DETAILS_TYPE.Bank}>Bank</option>
          <option value={APP_CONST.PLAYER_BANK_DETAILS_TYPE.Card}>Card</option>
        </Form.Select>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"text"}
            color="black"
            placeholder={"Account Name"}
            name={"accountName"}
            onChange={handleChange}
            value={formData?.accountName}
            isInvalid={!!formErrors["accountName"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {formErrors["accountName"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"number"}
            name={"accountNumber"}
            placeholder="Account Number"
            onChange={handleChange}
            //   value={bankDetails.accountNumber}
            isInvalid={!!formErrors["accountNumber"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {formErrors["accountNumber"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"text"}
            placeholder={"Bank name"}
            name={"bankName"}
            //   value={bankDetails.ifscCode}
            onChange={handleChange}
            isInvalid={!!formErrors["bankName"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {formErrors["bankName"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"text"}
            placeholder={"Ifsc code"}
            name={"ifscCode"}
            //   value={bankDetails.ifscCode}
            onChange={handleChange}
            isInvalid={!!formErrors["ifscCode"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {formErrors["ifscCode"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Button type="submit" disabled={isLoading}>
          {isLoading ? "Submitting.." : "Submit"}
        </Button>
      </Form>
    );
  };
  const renderCardDetailsForm = () => {
    return (
      <Form
        className={isEditMode ? "playerBankDetailsEdit" : "playerBankDetails"}
        onSubmit={handleCardFormSubmit}
      >
        {" "}
        <Form.Select
          aria-label="Default select example"
          className="mb-3 position-relative"
          name="type"
          onChange={(e) => {
            setFormDetailsType(e.target.value);

            // handleChange(e);
          }}
          isInvalid={!!formErrors["type"]}
          value={formDetailsType}
        >
          <option value={APP_CONST.PLAYER_BANK_DETAILS_TYPE.Bank}>Bank</option>
          <option value={APP_CONST.PLAYER_BANK_DETAILS_TYPE.Card}>Card</option>
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {formErrors["type"]}
          </Form.Control.Feedback>
        </Form.Select>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"text"}
            placeholder={"Card Name"}
            name={"cardName"}
            onChange={handleChange}
            //   value={bankDetails.cardName}
            isInvalid={!!formErrors["cardName"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {formErrors["cardName"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"number"}
            name={"cardNo"}
            placeholder="Card Number"
            onChange={handleChange}
            //   value={bankDetails.cardNo}
            isInvalid={!!formErrors["cardNo"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {formErrors["cardNo"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"number"}
            placeholder={"Expiry Month"}
            name={"expiryMonth"}
            //   value={bankDetails.expiryMonth}
            onChange={handleChange}
            isInvalid={!!formErrors["expiryMonth"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {formErrors["expiryMonth"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"number"}
            placeholder={"Expiry Year"}
            name={"expiryYear"}
            //   value={bankDetails.expiryYear}
            onChange={handleChange}
            isInvalid={!!formErrors["expiryYear"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {formErrors["expiryYear"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"number"}
            placeholder={"Cvv"}
            name={"cvv"}
            //   value={bankDetails.expiryYear}
            onChange={handleChange}
            isInvalid={!!formErrors["cvv"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {formErrors["cvv"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Button type="submit" disabled={isLoading}>
          {isLoading ? "Submitting.." : "Submit"}
        </Button>
      </Form>
    );
  };
  return formDetailsType === APP_CONST.PLAYER_BANK_DETAILS_TYPE.Bank
    ? renderBankDetailsForm()
    : renderCardDetailsForm();
};

export default BankDetailsForm;
